import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import PDFModal from '../../component/PDFModal.js';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import '../../Assets/css/resptable.css';
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';


export default function PrincipalExternalCreditApplication() {

    const navigate = useNavigate();
    const isAuth = useAuth();
    if (isAuth === false) navigate("/college/");

    const tableRef = useRef(null);

    const [errors, setErrors] = useState({ admyear: '', discipline_id: '' });
    const [admissionYears, setAdmissionYears] = useState([]);
    const [disciplines, setDisciplines] = useState([]);
    const [selectedDiscipline, setSelectedDiscipline] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [coursetype, setCoursetype] = useState(null);
    const [students, setStudents] = useState([]);
    const [courseDiciplineNameData, setCourseDiciplineNameData] = useState([]);
    const [collegeDiciplineSchemeID, setCollegeDiciplineSchemeID] = useState([]);
    const [courseDiciplineIDData, setCourseDiciplineIDData] = useState([]);
    const [courseDiciplineTypeData, setCourseDiciplineTypeData] = useState([]);
    const [collegeDiciplineTypeData, setCollegeDiciplineTypeData] = useState([]);
    const [courseDiciplineData, setCourseDiciplineData] = useState([]);
    const [flag, setflag] = useState(false);

    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalAction, setModalAction] = useState(null);
    const [selectedCredit, setSelectedCredit] = useState(null);
    const [creditID, setCreditID] = useState(null);
    const [remarks, setRemarks] = useState('');
    const [actionLoading, setActionLoading] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [viewLoading, setViewLoading] = useState(false);

    // PDF modal: url is an object URL (blob)
    const [pdfModal, setPdfModal] = useState({ show: false, url: '', name: '', type: '' });
    const [pdfLoading, setPdfLoading] = useState(false);
    const [semester_id, setSemester] = useState([]);
    const [reload, setReload] = useState(false);
    const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total_count, setTotal] = useState(null);
    const { http } = Api();

    // Cleanup blob URL when PDF modal closes
    useEffect(() => {
        return () => {
            if (pdfModal.url) URL.revokeObjectURL(pdfModal.url);
        };
    }, [pdfModal.url]);


    useEffect(() => {
        const fetchAdmissionYears = async () => {
            try {
                const response = await http.get("/Admin/getActiveAdmissionYear");
                const years = response.data.map((year) => ({
                    id: year.id,
                    value: year.admission_year,
                    label: year.admission_year,
                }));
                setAdmissionYears(years);
            } catch (error) {
                console.error("Error fetching admission years:", error);
            }
        };
        fetchAdmissionYears();
    }, []);


    const handleSemesterChange = (selectedOption) => {
        setSemester(selectedOption);
    };


    let cid = localStorage.getItem("collegeid");
    useEffect(() => {
        // 🚨 Stop execution on initial page load
        if (!selectedYear) return;

        const fetchDisciplines = async () => {

            try {
                const response = await http.get(`/Admin/getCollegeDisciplines`, {
                    params: {
                        limit: '500',
                        college_id: cid
                    }
                });
                if (response.data.status_code === 'ERR5') {
                    setflag(true);
                }
                const formatted = response.data.map(d => ({
                    value: `${d.discipline_id}-${d.college_course_type}`,
                    label: `${d.discipline_name}`,
                    discipline_id: d.discipline_id,
                    course_type: d.college_course_type
                }));
                setDisciplines(formatted);
            }
            catch (error) {
                if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);

                }
                else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error("Something went wrong");
                }
            }
        };
        fetchDisciplines();
    }, [selectedYear]);

    useEffect(() => {
        // 🚨 Stop execution on initial page load
        if (!selectedYear || !selectedDiscipline) return;

        const fetchStudents = async () => {
            try {
                setLoading(true);
                const response = await http.post('/College/getPrincipalCreditStudents', {
                    admissionyear: selectedYear || null,
                    // semester_id: semester_id || [],
                    discipline_id: selectedDiscipline,
                });
                setStudents(response.data.students || []);
                setCourseDiciplineNameData(response.data.discipline_name);
                setCourseDiciplineIDData(response.data.discipline_id);
                setCourseDiciplineTypeData(response.data.college_course_type);
                setCollegeDiciplineTypeData(response.data.college_discipline_type);
                setCollegeDiciplineSchemeID(response.data.scheme_id);

            } catch (err) {
                console.error('Error fetching students:', err);
                setStudents([]);
            } finally {
                setLoading(false);
            }
        };
        fetchStudents();
    }, [selectedYear, selectedDiscipline, reload]);




    const openActionModal = (student, credit_id, action) => {
        setSelectedCredit(student);
        setCreditID(credit_id);
        setModalAction(action);
        setRemarks('');
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedCredit(null);
        setCreditID(null);
        setModalAction(null);
        setRemarks('');
    };

    const handleConfirmAction = async () => {
        if (!selectedCredit || !modalAction) return;
        const status = modalAction === 'approve' ? 'forwarded_to_university' : 'rejected_to_candidate';
        try {
            setActionLoading(true);
            const res = await http.post('/College/updateExternalCreditStatus', {
                credit_id: creditID,
                status: status,
                remarks: remarks || null,
            });
            if (res.data.status) {
                const successMessage =
                    status === 'forwarded_to_university'
                        ? 'Data Forwarded to University Successfully'
                        : 'rejected_to_candidate' ? 'Application Rejected Successfully' : null;

                toast.success(successMessage);
                setStudents(prev =>
                    prev.map(s =>
                        s.credit_id === selectedCredit.credit_id ? { ...s, status } : s
                    )
                );
                setReload(!reload);
                closeModal();

            } else {
                toast.error(res.data.message || 'Status update failed');
            }
        } catch (err) {
            console.error('Error updating status:', err);
            toast.error('Something went wrong. Please try again.');
        } finally {
            setActionLoading(false);
        }
    };

    const openViewModal = async (student) => {
        setShowViewModal(true);
        setViewData(null);
        setViewLoading(true);
        try {
            const res = await http.post('/College/getStudentCreditApplication', {
                account_id: student.accountid,
                credit_id: student.id,
            });
            if (res.data.status) {
                setViewData(res.data.data);
            } else {
                toast.error('Failed to load application details.');
                setShowViewModal(false);
            }
        } catch (err) {
            console.error('Error fetching application details:', err);
            toast.error('Something went wrong while loading details.');
            setShowViewModal(false);
        } finally {
            setViewLoading(false);
        }
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setViewData(null);
    };

    /**
     * Fetch PDF as blob using encryptedKey, then open in modal
     */
    const openPdfModal = async (encryptedFile, fileName) => {
        setPdfLoading(true);
        try {
            const res = await http.get(
                `/College/fetchSecureExternalCreditPdf/${encodeURIComponent(encryptedFile)}`,
                { responseType: 'blob' }
            );

            const contentType = res.headers['content-type'];

            const blobUrl = URL.createObjectURL(
                new Blob([res.data], { type: contentType })
            );

            setPdfModal({
                show: true,
                url: blobUrl,
                name: fileName,
                type: contentType
            });
        } catch (err) {
            console.error('Error fetching file:', err);
            toast.error('Failed to load document. Please try again.');
        } finally {
            setPdfLoading(false);
        }
    };

    const closePdfModal = () => {
        if (pdfModal.url) URL.revokeObjectURL(pdfModal.url);
        setPdfModal({ show: false, url: '', name: '', type: '' }); // add type: ''
    };

    const handleDisciplineChange = (option) => {
        if (!option) return;
        setSelectedDiscipline(option.value);
        setCoursetype(option.course_type);
    };

    const handleAdmissionYearChange = (selectedOption) => {
        setSelectedYear(selectedOption.value);
    };

    const customStyles = {
        menu: (p) => ({ ...p, maxHeight: '200px', overflowY: 'auto' }),
        menuList: (p) => ({ ...p, maxHeight: '200px', overflowY: 'auto', scrollbarWidth: 'thin' }),
    };


    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleSort = (column) => {
        const newSortBy = {
            column,
            direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
        };
        setSortBy(newSortBy);
    };


    useEffect(() => {
        const filteredAndSortedData = [...students].filter(item => {
            const query = searchQuery.toLowerCase();

            return (
                String(item.prn ?? '').toLowerCase().includes(query) ||
                String(item.accountid ?? '').toLowerCase().includes(query) ||
                String(item.studentname ?? '').toLowerCase().includes(query) ||
                String(item.apaar_no ?? '').toLowerCase().includes(query) ||
                String(item.course_name ?? '').toLowerCase().includes(query) ||
                String(item.acquired_credits ?? '').toLowerCase().includes(query) ||
                String(item.application_status ?? '').toLowerCase().includes(query) ||
                String(item.application_status_label ?? '').toLowerCase().includes(query)

            );
        }).sort((a, b) => {
            if (sortBy.direction === 'asc') {
                return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
            } else {
                return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
            }
        });

        const itemsPerPage = 50;
        const startIndex = (currentPage - 1) * itemsPerPage;
        const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

        setfilteredAndSortedData(paginatedData);
        setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
        setTotal(filteredAndSortedData.length);

    }, [searchQuery, sortBy, students, currentPage]);

    const renderSortIcon = (columnName) => {
        if (sortBy.column === columnName) {
            return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
        }
        return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    /* DATA TABLE END */
    const statusBadgeMap = {
        "Submitted by Student": "bg-blue-clr",
        "Forwarded to Principal": "bg-success",
        "Forwarded to University": "bg-success",
        "Forwarded to BOS": "bg-success",
        "Application Rejected": "bg-danger",
    };

    const disciplineStyles = {
        option: (provided, state) => {
            const suffix = (state.data.label || "").split("-")[1]?.trim();
            let color = suffix === "SF" ? "#252393" : suffix === "AIDED" ? "green" : "black";
            return state.isSelected
                ? { ...provided, backgroundColor: "#ebebeb", color, fontWeight: "600" }
                : { ...provided, color };
        },
        singleValue: (provided, state) => {
            const suffix = (state.data.label || "").split("-")[1]?.trim();
            let color = suffix === "SF" ? "#252393" : suffix === "AIDED" ? "green" : "black";
            return { ...provided, color, fontWeight: "600" };
        },
        menu: (p) => ({ ...p, maxHeight: '200px', overflowY: 'auto' }),
        menuList: (p) => ({ ...p, maxHeight: '200px', overflowY: 'auto', scrollbarWidth: 'thin' }),
    };

    return (
        <>
            <ToastContainer />
            <Template>
                <div className="adl-stl-page">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="col-md-12">
                                        <div className="card-header">
                                            <div className="py-3 d-flex justify-content-between align-items-center">
                                                <h5>Admitted Students</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="card-body pdg">
                                            <div className="table-responsive">
                                                <form className="form theme-form">
                                                    <div className="card-body custom-input">
                                                        <div className="col">
                                                            <div className="row m-b-20">
                                                                <div className="col-md-6">
                                                                    <label>Admission Year <span className="errorclr">*</span></label>
                                                                    <Select
                                                                        maxMenuHeight={200}
                                                                        menuPlacement="auto"
                                                                        id="admission_year"
                                                                        name="admission_year"
                                                                        className="form w-100"
                                                                        styles={customStyles}
                                                                        options={admissionYears}
                                                                        onChange={handleAdmissionYearChange}
                                                                    />
                                                                    {errors.admyear && <p className="text-danger">{errors.admyear}</p>}
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label>Discipline <span className="errorclr">*</span></label>
                                                                    <Select
                                                                        maxMenuHeight={200}
                                                                        menuPlacement="auto"
                                                                        id="discipline_id"
                                                                        name="discipline_id"
                                                                        className="form"
                                                                        styles={disciplineStyles}
                                                                        onChange={handleDisciplineChange}
                                                                        options={flag ? [{ value: '0', label: 'No data found' }] : disciplines}
                                                                    />
                                                                    {errors.discipline_id && <p className="text-danger">{errors.discipline_id}</p>}
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className=''>

                                                                {courseDiciplineNameData && courseDiciplineNameData.length > 0 ? (
                                                                    <div className="txt-aln sfa-dis-headg">
                                                                        <h5> Department/Discipline:  {courseDiciplineNameData}{collegeDiciplineSchemeID === 4 ? '(B.Voc)' : ''} {collegeDiciplineTypeData == 1 ? '- Single Faculty Course' : ''} </h5>
                                                                    </div>
                                                                ) : (null

                                                                )}
                                                            </div>

                                                            <div className='col-md-6 wdt' >
                                                                <p>
                                                                    Showing {(currentPage - 1) * 50 + 1}{''}-
                                                                    {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                                                                </p>
                                                            </div>
                                                            <div className='col-md-6 wdt' align='right'>
                                                                <input
                                                                    type="text"
                                                                    value={searchQuery}
                                                                    onChange={handleSearchInputChange}
                                                                    placeholder="Search..."
                                                                    className='form-control'
                                                                /></div></div>
                                                        <div class="table-container" style={{ overflowX: 'unset' }}>

                                                            <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef}>

                                                                <thead>
                                                                    <tr className="bg-primary">
                                                                        <th onClick={() => handleSort('PRN')} width="17%" style={{ textAlign: "left", verticalAlign: "middle" }}>PRN &nbsp; {renderSortIcon('PRN')} </th>

                                                                        <th onClick={() => handleSort('studentname')} width="17%">Student Name &nbsp; {renderSortIcon('studentname')}</th>
                                                                        <th onClick={() => handleSort('')}>Course Name &nbsp; {renderSortIcon('course_name')}</th>
                                                                        <th onClick={() => handleSort('acquired_credits')} width="">Course Credit &nbsp; {renderSortIcon('acquired_credits')}</th>
                                                                        <th onClick={() => handleSort('application_status_label')} width="">Appication Status &nbsp; {renderSortIcon('application_status_label')}</th>
                                                                        <th width="25%">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                    {filteredAndSortedData.length > 0 ? (
                                                                        filteredAndSortedData.map((student) => {
                                                                            console.log(student.id)
                                                                            const isStudentSubmitted =
                                                                                student.application_status === 'forwarded_to_principal';

                                                                            return (
                                                                                <tr key={student.accountid}>
                                                                                    <td className=''>{student.prn}</td>
                                                                                    <td className=''>{student.studentname}</td>
                                                                                    <td className=''>{student.course_name}</td>
                                                                                    <td className='text-center'>{student.acquired_credits}</td>
                                                                                    <td className='text-center'>
                                                                                        <span
                                                                                            className={`badge ${statusBadgeMap[student.application_status_label] ||
                                                                                                "bg-warning text-dark"
                                                                                                }`}
                                                                                        >
                                                                                            {student.application_status_label || "Pendingg"}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td className=''>
                                                                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-info btn-sm mb-2 w-75"
                                                                                                onClick={() => openViewModal(student)}
                                                                                                title="View"
                                                                                            >
                                                                                                <i className="fa fa-eye"></i>
                                                                                            </button>
                                                                                            {/* SHOW ONLY IF isForwarded === true */}
                                                                                            {/* Forward & Reject ONLY when forwarded_to_principal */}
                                                                                            {isStudentSubmitted && (
                                                                                                <>
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-success btn-sm mb-2 w-75"
                                                                                                        onClick={() =>
                                                                                                            openActionModal(student, student.id, 'approve')
                                                                                                        }
                                                                                                        title="Forward to University"
                                                                                                    >
                                                                                                        <i className="fa fa-check mr-1"></i> Forward
                                                                                                    </button>

                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-danger btn-sm w-75"
                                                                                                        onClick={() =>
                                                                                                            openActionModal(student, student.id, 'reject')
                                                                                                        }
                                                                                                        title="Reject to Candidate"
                                                                                                    >
                                                                                                        <i className="fa fa-times mr-1"></i> Reject
                                                                                                    </button>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="6" className="text-center">No students found</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        {totalPages > 1 && (
                                                            <nav aria-label="..." style={{ cursor: "pointer" }}>
                                                                <ul className="pagination justify-content-center">
                                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                        <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                                                    </li>
                                                                    <li className={`page-item`}>
                                                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                                                    </li>
                                                                    {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                                    {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                                                        <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                                                            <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                                                        </li>
                                                                    ))}
                                                                    {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                                                    <li className={`page-item`}>
                                                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                                                    </li>

                                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                        <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                                                    </li>
                                                                </ul>
                                                            </nav>
                                                        )}
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Template>

            {/* ── Confirmation Modal ── */}
            {showModal && (
                <div
                    className="modal fade show"
                    style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className={`modal-header ${modalAction === 'approve' ? 'bg-success' : 'bg-danger'} text-white`}>
                                <h5 className="modal-title">
                                    {modalAction === 'approve'
                                        ? <><i className="fa fa-check-circle mr-2"></i>Forward Application</>
                                        : <><i className="fa fa-times-circle mr-2"></i>Reject Application</>}
                                </h5>
                                <button type="button" className="btn-close text-white" onClick={closeModal} disabled={actionLoading}>

                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mb-2">
                                    {modalAction === 'approve'
                                        ? 'Are you sure you want to forward this application to University?'
                                        : 'Are you sure you want to reject this application to the candidate?'}
                                </p>
                                {selectedCredit && (
                                    <div className="alert alert-light border mb-3">
                                        <strong>Student:</strong> {selectedCredit.studentname}<br />
                                        <strong>PRN:</strong> {selectedCredit.prn}<br />
                                        <strong>Course:</strong> {selectedCredit.course_name}
                                    </div>
                                )}
                                {modalAction !== 'approve' && (
                                    <div className="form-group mb-0">
                                        <label>Remarks <span className="text-muted">(optional)</span></label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            maxLength={500}
                                            placeholder="Enter remarks..."
                                            value={remarks}
                                            onChange={(e) => setRemarks(e.target.value)}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeModal} disabled={actionLoading}>Cancel</button>
                                <button
                                    type="button"
                                    className={`btn ${modalAction === 'approve' ? 'btn-success' : 'btn-danger'}`}
                                    onClick={handleConfirmAction}
                                    disabled={actionLoading}
                                >
                                    {actionLoading
                                        ? <><span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span> Processing...</>
                                        : modalAction === 'approve' ? 'Confirm Forward' : 'Confirm Reject'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── View Application Modal (new style) ── */}
            <style>{`
    .view-modal-overlay {
        position: fixed; top: 0; left: 0;
        width: 100%; height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 1050;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
        box-sizing: border-box;
    }
    .view-modal-dialog {
        width: 100%; max-width: 860px;
        height: 90vh;
        display: flex;
        flex-direction: column;
    }
    .view-modal-content {
        height: 100%; display: flex; flex-direction: column;
        overflow: hidden; border-radius: 10px;
        box-shadow: 0 8px 32px rgba(0,0,0,0.18);
    }
    .view-modal-header {
        background: #fff;
        border-bottom: 2px solid #e9ecef;
        padding: 0.85rem 1.25rem;
        display: flex; align-items: center; justify-content: space-between;
        flex-shrink: 0;
    }
    .view-modal-header .modal-title {
        font-size: 1rem; font-weight: 700;
        color: #212529; margin: 0;
    }
    .view-modal-body {
        overflow-y: auto; flex: 1;
        padding: 1.25rem; background: #f4f5f7;
    }
    .student-banner {
        background: #fff;
        border: 1px solid #e9ecef;
        border-radius: 10px;
        padding: 1rem 1.25rem;
        margin-bottom: 1.25rem;
        display: flex; gap: 2rem; flex-wrap: wrap; align-items: center;
        box-shadow: 0 1px 3px rgba(0,0,0,0.06);
    }
    .student-banner .s-item { display: flex; flex-direction: column; }
    .student-banner .s-label {
        font-size: 0.68rem; text-transform: uppercase;
        letter-spacing: 0.06em; color: #6c757d; font-weight: 600;
    }
    .student-banner .s-value {
        font-size: 0.95rem; font-weight: 700; color: #212529;
    }
    .app-card {
        background: #fff; border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0,0,0,0.07);
        margin-bottom: 1.25rem; overflow: hidden;
        border: 1px solid #e9ecef;
    }
    .app-card-header {
        background: #343a40;
        color: #fff; padding: 0.65rem 1rem;
        display: flex; justify-content: space-between; align-items: center;
    }
    .app-card-header strong { font-size: 0.9rem; }
    .section-divider {
        font-size: 0.68rem; font-weight: 700;
        text-transform: uppercase; letter-spacing: 0.08em;
        color: #6c757d; padding: 0.6rem 1rem 0.25rem;
        border-top: 1px solid #f0f0f0; margin-top: 0.1rem;
        background: #fff;
    }
    .info-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
        gap: 0.85rem; padding: 0.85rem 1rem 1rem;
        background: #fff;
    }
    .info-item { display: flex; flex-direction: column; }
    .info-label {
        font-size: 0.68rem; font-weight: 700;
        text-transform: uppercase; letter-spacing: 0.05em;
        color: #6c757d; margin-bottom: 3px;
    }
    .info-value { font-size: 0.88rem; color: #212529; font-weight: 500; }
    .info-value.empty { color: #adb5bd; font-style: italic; font-weight: 400; }
    .badge-status {
        font-size: 0.70rem; padding: 0.3em 0.7em;
        border-radius: 20px; font-weight: 600;
    }
    .docs-area { padding: 0.75rem 1rem 1rem; background: #fff; }
    .doc-row {
        display: flex; align-items: center;
        justify-content: space-between;
        background: #f8f9fa; border: 1px solid #e9ecef;
        border-radius: 6px; padding: 0.5rem 0.75rem;
        margin-bottom: 0.5rem;
    }
    .doc-row:last-child { margin-bottom: 0; }
    .doc-name {
        font-size: 0.82rem; color: #495057;
        display: flex; align-items: center; gap: 0.5rem;
    }
    .view-modal-footer {
        border-top: 1px solid #e9ecef;
        background: #fff; padding: 0.75rem 1.25rem;
        display: flex; justify-content: flex-end;
        flex-shrink: 0;
    }
    @media (max-width: 768px) {
        .view-modal-header .modal-title { font-size: 0.9rem; }
        .info-grid { grid-template-columns: repeat(2, 1fr); }
        .student-banner { gap: 1rem; }
    }
`}</style>

            {showViewModal && (
                <div className="view-modal-overlay">
                    <div className="view-modal-dialog">
                        <div className="view-modal-content">

                            {/* Header */}
                            <div className="view-modal-header">
                                <h5 className="modal-title">
                                    <i className="fa fa-file-text-o mr-2 text-muted"></i>
                                    Application Details
                                    {viewData?.student && (
                                        <small style={{ fontSize: '0.78rem', color: '#6c757d', marginLeft: '0.5rem', fontWeight: 500 }}>
                                            — {viewData.student.studentname}
                                        </small>
                                    )}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={closeViewModal}
                                >
                                </button>
                            </div>

                            {/* Body */}
                            <div className="view-modal-body">
                                {viewLoading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-secondary" role="status" />
                                        <p className="mt-3 text-muted" style={{ fontSize: '0.9rem' }}>
                                            Loading application details...
                                        </p>
                                    </div>
                                ) : viewData?.applications?.length > 0 ? (
                                    <>
                                        {/* Student Banner */}
                                        <div className="student-banner">
                                            <div className="s-item">
                                                <span className="s-label">Student Name</span>
                                                <span className="s-value">{viewData.student.studentname}</span>
                                            </div>
                                            <div className="s-item">
                                                <span className="s-label">PRN</span>
                                                <span className="s-value">{viewData.student.prn}</span>
                                            </div>
                                            <div className="s-item">
                                                <span className="s-label">Admission Year</span>
                                                <span className="s-value">{viewData.student.admissionyear}</span>
                                            </div>
                                            <div className="s-item">
                                                <span className="s-label">Discipline</span>
                                                <span className="s-value">{viewData.student.discipline_name}</span>
                                            </div>
                                        </div>

                                        {/* Application Cards */}
                                        {viewData.applications.map((app, idx) => {
                                            const categoryMap = {
                                                1: 'DSC', 2: 'DCC', 3: 'MDC', 4: 'AEC',
                                                5: 'DCE', 6: 'DSE', 7: 'SEC', 8: 'VAC',
                                                9: 'MDE', 10: 'SDC', 11: 'MPC',
                                            };
                                            const categoryLabel = categoryMap[app.course_category] || app.course_category || '—';
                                            const isRejected = app.application_status === 'rejected_to_candidate';

                                            return (
                                                <div key={app.application_id} className="app-card">

                                                    {/* Card Header */}
                                                    <div className="app-card-header">
                                                        <strong>
                                                            <i className="fa fa-graduation-cap mr-2"></i>
                                                            &nbsp;&nbsp;&nbsp;{app.course_name}
                                                        </strong>
                                                        <span
                                                            className="badge-status"
                                                            style={{
                                                                background: isRejected ? '#dc3545' : '#28a745',
                                                                color: '#fff',
                                                            }}
                                                        >
                                                            {app.application_label}
                                                        </span>
                                                    </div>

                                                    {/* Course Details */}
                                                    <div className="section-divider">Course Details</div>
                                                    <div className="info-grid">
                                                        <div className="info-item">
                                                            <span className="info-label">Course Category</span>
                                                            <span className={`info-value ${!app.course_category ? 'empty' : ''}`}>
                                                                {categoryLabel}
                                                            </span>
                                                        </div>
                                                        <div className="info-item">
                                                            <span className="info-label">NHEQF Level</span>
                                                            <span className={`info-value ${!app.course_level ? 'empty' : ''}`}>
                                                                {app.course_level || 'N/A'}
                                                            </span>
                                                        </div>
                                                        <div className="info-item">
                                                            <span className="info-label">Platform</span>
                                                            <span className={`info-value ${!app.platform ? 'empty' : ''}`}>
                                                                {app.platform || 'N/A'}
                                                            </span>
                                                        </div>
                                                        <div className="info-item">
                                                            <span className="info-label">Mode</span>
                                                            <span className={`info-value ${!app.mode ? 'empty' : ''}`}>
                                                                {app.mode || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Grade & Credits */}
                                                    <div className="section-divider">Grade & Credits</div>
                                                    <div className="info-grid">
                                                        <div className="info-item">
                                                            <span className="info-label">Course Credits</span>
                                                            <span className="info-value" style={{ fontWeight: 700 }}>
                                                                {app.acquired_credits ?? '—'}
                                                            </span>
                                                        </div>
                                                        <div className="info-item">
                                                            <span className="info-label">Grade</span>
                                                            <span className={`info-value ${!app.grade ? 'empty' : ''}`}>
                                                                {app.grade || 'N/A'}
                                                            </span>
                                                        </div>
                                                        <div className="info-item">
                                                            <span className="info-label">Grade Point</span>
                                                            <span className={`info-value ${app.grade_point == null ? 'empty' : ''}`}>
                                                                {app.grade_point ?? 'N/A'}
                                                            </span>
                                                        </div>
                                                        <div className="info-item">
                                                            <span className="info-label">Grade Scale</span>
                                                            <span className={`info-value ${!app.grade_scale ? 'empty' : ''}`}>
                                                                {app.grade_scale || 'N/A'}
                                                            </span>
                                                        </div>
                                                        <div className="info-item">
                                                            <span className="info-label">Percentage</span>
                                                            <span className={`info-value ${app.percentage == null ? 'empty' : ''}`}>
                                                                {app.percentage != null ? `${app.percentage}%` : 'N/A'}
                                                            </span>
                                                        </div>
                                                        <div className="info-item">
                                                            <span className="info-label">Applied On</span>
                                                            <span className="info-value">
                                                                {app.created_at
                                                                    ? new Date(app.created_at).toLocaleDateString('en-IN', {
                                                                        day: '2-digit', month: 'short', year: 'numeric'
                                                                    })
                                                                    : '—'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Documents */}
                                                    {app.documents?.length > 0 && (
                                                        <>
                                                            <div className="section-divider">
                                                                <i className="fa fa-paperclip mr-1"></i> Documents
                                                            </div>
                                                            <div className="docs-area">
                                                                {app.documents.map((doc, dIdx) => (
                                                                    <div key={dIdx} className="doc-row">
                                                                        <div className="doc-name">
                                                                            <i className="fa fa-file-pdf-o text-danger" style={{ fontSize: '1rem' }}></i>
                                                                            <span>
                                                                                {doc.file_name.length > 45
                                                                                    ? doc.file_name.substring(0, 45) + '…'
                                                                                    : doc.file_name}
                                                                            </span>
                                                                        </div>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-outline-secondary"
                                                                            style={{ minWidth: '75px', fontSize: '0.8rem' }}
                                                                            disabled={pdfLoading}
                                                                            onClick={() => openPdfModal(doc.encryptedFile, doc.file_name)}
                                                                        >
                                                                            {pdfLoading
                                                                                ? <span className="spinner-border spinner-border-sm" />
                                                                                : <><i className="fa fa-eye mr-1"></i>View</>}
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>
                                                    )}

                                                    {app.documents?.length === 0 && (
                                                        <div style={{ padding: '0.65rem 1rem 0.85rem', color: '#adb5bd', fontSize: '0.82rem', background: '#fff' }}>
                                                            <i className="fa fa-info-circle mr-1"></i> No documents attached.
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </>
                                ) : (
                                    !viewLoading && (
                                        <div className="text-center py-5 text-muted">
                                            <i className="fa fa-inbox fa-3x mb-3 d-block" style={{ opacity: 0.25 }}></i>
                                            <p style={{ fontSize: '0.9rem' }}>No application records found for this student.</p>
                                        </div>
                                    )
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {/* ── PDF Blob Viewer Modal ── */}
            {/* {pdfModal.show && (
                <div
                    className="modal fade show"
                    onClick={closePdfModal}
                    style={{
                        display: 'block',
                        backgroundColor: 'rgba(0,0,0,0.75)',
                        zIndex: 1065,
                    }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        style={{ maxWidth: '90vw', margin: '1rem auto' }}
                        role="document"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-content" style={{ height: '90vh' }}>
                            <div className="modal-header bg-dark text-white py-2">
                                <h6 className="modal-title mb-0">
                                    <i className="fa fa-file-pdf-o mr-2"></i>
                                    {pdfModal.name}
                                </h6>
                                <button type="button" className="close text-white" onClick={closePdfModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div
                                className="modal-body p-0"
                                style={{ flex: 1, overflow: 'hidden', height: 'calc(100% - 51px)' }}
                            >
                                <iframe
                                    src={`${pdfModal.url}#toolbar=0`}
                                    title={pdfModal.name}
                                    style={{ width: '100%', height: '100%', border: 'none' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )} */}


            <PDFModal
                isOpen={pdfModal.show}
                onClose={closePdfModal}
                pdfUrl={pdfModal.url}
                fileName={pdfModal.name}
                fileType={pdfModal.type}
            />
        </>
    );
}